// extracted by mini-css-extract-plugin
export default {"editableBox":"MultipleReasonCodes_editableBox__5Kx5D","editableBoxFocused":"MultipleReasonCodes_editableBoxFocused__pi5y9","editableInput":"MultipleReasonCodes_editableInput__PiCf8"};